import { DATASET_ID_CHANGE, INIT_DATASET_LIST, CLEAR_ID_INFO, 
    INIT_DATA, API_ID_CHANGE, TASK_ID_CHANGE, 
    API_ID_LIST_CHANGE, INIT_EXPLORE_META_DATA, 
    MODE_ID_CHANGE, VIEW_MODE_CHANGE, CHANGE_EXPLORE_LOADING} from '../constants';

// Define Change Model Methods
export const changeDataset = (dataset_id:number | null) =>({
    type: DATASET_ID_CHANGE,
    dataset_id: dataset_id
})
export const changeAPI = (api_id:number | null) =>({
    type: API_ID_CHANGE,
    api_id: api_id
})
export const changeAPIList = (api_id_list: any) =>({
    type: API_ID_LIST_CHANGE,
    api_id_list: api_id_list
})
export const changeTask = (task_id:number | null) =>({
    type: TASK_ID_CHANGE,
    task_id: task_id
})
export const changeMode = (mode_id: number) =>({
    type: MODE_ID_CHANGE,
    mode_id: mode_id
})
export const changeViewMode = (view_mode: number) =>({
    type: VIEW_MODE_CHANGE,
    view_mode: view_mode
})
export const clearIdInfo = () =>({
    type: CLEAR_ID_INFO
})

export const initDatasetList = (datasetList:any) =>({
    type: INIT_DATASET_LIST,
    datasetList: datasetList
})

export const initData = (data:any) =>({
    type: INIT_DATA,
    data: data
})

export const initExploreMetaData = (explore_meta_data:any) => ({
    type: INIT_EXPLORE_META_DATA,
    explore_meta_data: explore_meta_data
})


export const changeExploreLoading = (explore_loading:boolean) => ({
    type: CHANGE_EXPLORE_LOADING,
    explore_loading: explore_loading
})